angular.module('TetherApp').controller('ShortcodeController', [
    'ngToast',
    '$window',
    function (
        ngToast,
        $window
    ) {
        let self = this;

        self.init = function(start, end) {
            self.start_date = new Date(start);
            self.end_date = new Date(end);
        }
    }
]);



